// extracted by mini-css-extract-plugin
module.exports = {"settingsNotifications":"SettingsNotifications_settingsNotifications__2Mfj-","muted":"SettingsNotifications_muted__1c2br","link":"SettingsNotifications_link__8wequ"};